import { get } from 'lodash';
import BaseService from '@peoplenet/vi-components-ui/src/middleware/BaseService';
import { geotabService } from '../geotab/geotabService';

class CustomerService extends BaseService {
  prefix = '/customers';

  async updateName() {
    const companyName = await this.getCompanyName();

    await this.post({
      companyName,
    });
  }

  async getSettings() {
    return this.get('setting');
  }

  async getCompanyName() {
    const companyData = await geotabService('Get', {
      typeName: 'SystemSettings',
      resultsLimit: 1,
      search: {},
    });

    return get(companyData, '0.companyName');
  }
}

export default new CustomerService();
